'use strict';
/* eslint-disable camelcase, no-undef */
__webpack_public_path__ = (window.kraken && window.kraken.productConfig.publicPath) || '/';
/* eslint-enable camelcase, no-undef */
